module.exports = __webpack_public_path__ + "static/media/gal3.ed548617.JPG";